// Import model
import { StartEstimateSignProposalRequest } from '../models/StartEstimateSignProposalRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateSignProposalRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateSignProposalRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateSignProposalRequest instance
   */
  static deserialize(json: string): StartEstimateSignProposalRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateSignProposalRequest instance
   */
  static fromObject(obj: any): StartEstimateSignProposalRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateSignProposalRequest');
    }


    const instance: StartEstimateSignProposalRequest = {
      templateId: obj['TemplateId'] as string | undefined,
      submitterEmail: obj['SubmitterEmail'] as string | undefined,
      submitterName: obj['SubmitterName'] as string | undefined,
      name: obj['Name'] as string | undefined,
      submitterRole: obj['SubmitterRole'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateSignProposalRequest instances
   */
  static deserializeArray(json: string): StartEstimateSignProposalRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateSignProposalRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateSignProposalRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateSignProposalRequest instance to a plain object
   */
  static toObject(instance: StartEstimateSignProposalRequest): any {
    return {
      'TemplateId': instance.templateId,
      'SubmitterEmail': instance.submitterEmail,
      'SubmitterName': instance.submitterName,
      'Name': instance.name,
      'SubmitterRole': instance.submitterRole,
    };
  }

  /**
   * Serializes an array of StartEstimateSignProposalRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateSignProposalRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
